import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/comics';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
            <nav className="flex items-center gap-2 text-sm mb-4">
              <Link to="/" className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
              <span className="text-foreground-400">/</span>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              关于妖精漫画
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              妖精漫画免费阅读韩漫官网 - 了解我们的品牌故事与使命
            </p>
          </div>
        </div>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-100">
                <i className="ri-book-open-line text-3xl" style={{ color: `oklch(var(--primary-500))` }}></i>
              </div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">品牌介绍</h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                妖精漫画成立于2020年，是一家专注于韩国漫画在线免费阅读的平台。作为免费阅读韩漫官网，我们致力于为广大漫画爱好者打造海量韩国漫画作品的集中入口。平台收录了来自韩国的各类优质漫画作品，涵盖恋爱、奇幻、动作、悬疑、搞笑等多种类型，满足不同读者的阅读需求。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mt-4">
                我们始终坚持"免费阅读、优质内容、便捷体验"的核心理念。妖精漫画的每一部作品都经过精心筛选，确保画质清晰、翻译准确、更新及时。无论是热门连载还是经典完结，您都能在这里找到心仪的韩漫作品。选择多样，导航清晰，助您轻松在浩瀚书海中找到所爱。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-100">
                  <i className="ri-book-read-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">海量作品</h3>
                <p className="text-sm text-foreground-500">收录数千部优质韩国漫画，覆盖多种类型，持续更新中</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-100">
                  <i className="ri-shield-check-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">完全免费</h3>
                <p className="text-sm text-foreground-500">所有漫画作品无需付费即可阅读，让阅读无负担</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-secondary-100">
                  <i className="ri-smartphone-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">多端阅读</h3>
                <p className="text-sm text-foreground-500">完美适配手机、平板和电脑，随时随地畅享阅读</p>
              </div>
            </div>

            <div className="mb-12">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6 text-center">读者口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-sm" style={{ color: `oklch(var(--accent-500))` }}></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 mb-3">"妖精漫画真的是太棒了！我一直追的韩漫在这里都能找到，更新也很快。作为免费阅读韩漫官网，这个入口真的很好用，推荐给所有喜欢韩漫的朋友！"</p>
                  <p className="text-xs text-foreground-500 font-medium">—— 漫画迷小陈</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-sm" style={{ color: `oklch(var(--accent-500))` }}></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 mb-3">"分类很清晰，海量韩国漫画作品任你选，找漫画特别方便。每天有空就上来看看有没有更新，已经成为习惯了。"</p>
                  <p className="text-xs text-foreground-500 font-medium">—— 资深读者小王</p>
                </div>
                <div className="p-5 rounded-xl bg-background-100 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-3">
                    {[1,2,3,4,5].map((i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-sm" style={{ color: `oklch(var(--accent-500))` }}></i>
                      </div>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 mb-3">"手机上阅读体验也很好，画质清晰。妖精漫画这个免费阅读韩漫入口真的很方便，推荐给了好多朋友。"</p>
                  <p className="text-xs text-foreground-500 font-medium">—— 韩漫爱好者小林</p>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-6 text-center">常见问题</h2>
              <div className="space-y-3">
                {faqs.map((faq, idx) => (
                  <details key={idx} className="group rounded-xl bg-background-100 border border-background-200/60 overflow-hidden">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100/80 transition-colors list-none">
                      <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform group-open:rotate-180">
                        <i className="ri-arrow-down-s-line text-foreground-500"></i>
                      </div>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>

            <div className="rounded-xl bg-background-100 border border-background-200/60 p-8 text-center">
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-3">联系我们</h2>
              <p className="text-sm text-foreground-500 mb-6">
                如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-8">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100">
                    <i className="ri-mail-line text-lg text-secondary-600"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-xs text-foreground-400">电子邮箱</p>
                    <p className="text-sm font-medium text-foreground-800">contact@yaojingmanhua.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100">
                    <i className="ri-customer-service-line text-lg text-secondary-600"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-xs text-foreground-400">在线客服</p>
                    <p className="text-sm font-medium text-foreground-800">工作日 9:00 - 18:00</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "妖精漫画",
            "url": "https://yaojingmanhua.com",
            "description": "妖精漫画作为免费阅读韩漫官网，是海量韩国漫画作品的集中入口",
            "contactPoint": {
              "@type": "ContactPoint",
              "email": "contact@yaojingmanhua.com",
              "contactType": "customer service",
              "availableLanguage": "Chinese"
            }
          })
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqs.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            }))
          })
        }}
      />
    </>
  );
}